<template>
    <AdminPageInner :breadcrumbs="breadcrumbs">
        <template #heading>Create Course</template>

        <CourseForm @submit="onSubmit">
            <template #footer>
                <div class="flex flex-row-reverse items-center">
                    <SubmitButton
                        :submitting="form.processing"
                        :disabled="form.errors.any()">
                        Create
                    </SubmitButton>
                    <router-link :to="redirectRoute" class="text-gray-500 mr-4">
                        Cancel
                    </router-link>
                </div>
            </template>
        </CourseForm>
    </AdminPageInner>
</template>

<script>

import axios from "axios";
import AdminPageInner from "@/Components/Layout/AdminPageInner";
import CourseForm from "@/Pages/Admin/Courses/Components/Form";
import SubmitButton from "@/Components/Form/SubmitButton";

export default {

    name: "CourseCreatePage",

    data() {
        return {
            form: this.$form({
                title: '',
                summary: '',
                description: '',
                pathway_id: '',
                credits: '',
                multipart: false,
                main_image_id: '',
                thumbnail_image_id: '',
                type: 1,
                trainer_ids: [],
                moderator_ids: [],
                publish: false,
                modules: [],
            }),
        }
    },

    provide() {
        return {
            form: this.form,
        }
    },

    components: {
        AdminPageInner,
        CourseForm,
        SubmitButton
    },

    methods: {
        onSubmit() {

            if (this.form.processing) {
                return;
            }

            this.form.post(route('api.courses.store'))
                .then(() => {
                    this.$notify.success('Course created');
                    this.$router.push(this.redirectRoute);
                })
                .catch(console.error);
        },
    },

    computed: {
        breadcrumbs() {
            return [
                {label: 'Admin', to: {name: 'admin'}},
                {label: 'Courses', to: {name: 'admin.courses.index'}},
                {label: `Create`, to: {name: this.$route.name, params: this.$route.params}},
            ];
        },
        redirectRoute() {
            return this.$route.meta.previous ? this.$route.meta.previous : {name: 'admin.courses.index'};
        }
    },

    async beforeRouteEnter(to, from, next) {
        await axios.head(route('api.courses.create'))
        next();
    },
};

</script>
